import { Link, useLocation, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { ArrowLeft, Compass, Home } from "lucide-react";

import banner404 from "@/assets/404-banner.jpg";
import { Button } from "@/components/ui/button";

function NotFound() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-5xl grid gap-10 lg:grid-cols-2 lg:gap-12 items-center">
        {/* Conteúdo */}
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
          <div className="inline-flex items-center gap-2 rounded-full border bg-muted/40 px-3 py-1 text-xs text-muted-foreground mb-4">
            <Compass className="h-3.5 w-3.5" />
            {t("notFound.code")}
          </div>

          <h1 className="text-5xl font-semibold tracking-tight lg:text-6xl">
            {t("notFound.title")}
          </h1>

          <p className="mt-4 max-w-md text-muted-foreground text-base">
            {t("notFound.description")}
          </p>

          {/* Rota tentada */}
          {location.pathname && location.pathname !== "/" && (
            <div className="mt-5 inline-flex items-center gap-2 rounded-md border bg-muted/30 px-3 py-1.5 text-xs">
              <span className="text-muted-foreground">
                {t("notFound.triedToAccess")}
              </span>
              <code className="text-foreground font-medium">
                {location.pathname}
              </code>
            </div>
          )}

          <div className="mt-8 flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
            <Button
              variant="outline"
              onClick={() => navigate(-1)}
              className="w-full sm:w-auto"
            >
              <ArrowLeft className="h-4 w-4" />
              {t("notFound.goBack")}
            </Button>
            <Button asChild className="w-full sm:w-auto">
              <Link to="/">
                <Home className="h-4 w-4" />
                {t("notFound.goHome")}
              </Link>
            </Button>
          </div>
        </div>

        {/* Banner */}
        <div className="order-first lg:order-last flex justify-center">
          <img
            src={banner404}
            alt={t("notFound.title")}
            className="max-h-80 w-auto opacity-90 grayscale transition-all duration-500 hover:grayscale-0 hover:opacity-100"
          />
        </div>
      </div>
    </div>
  );
}

export default NotFound;
